import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IBlog,
  IBlogPage,
  IBlogState,
  ICommentResponseData,
  IEditBlog,
} from "../types/blog";

const initialState: IBlogState = {
  blogs: [],
  blog: null,
  comments: [],
  commentsBlogId: null,
  commentsTotal: 0,
  commentsLoading: false,
  commentsError: null,
  total: 0,
  limit: 20,
  offset: 0,
  loading: false,
  loadingBlogId: null,
};

export const blog = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setBlogs: (state, action: PayloadAction<IBlogPage>) => {
      state.blogs = action.payload.data;
      state.total = action.payload.total;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
    },
    setBlog: (state, action: PayloadAction<IBlog>) => {
      state.blog = action.payload;
    },
    loadComments: (state, action: PayloadAction<number>) => {
      state.commentsBlogId = action.payload;
      state.comments = [];
      state.commentsTotal = 0;
      state.commentsError = null;
      state.commentsLoading = true;
    },
    setComments: (
      state,
      action: PayloadAction<{ blogId: number; data: ICommentResponseData }>,
    ) => {
      if (state.commentsBlogId !== action.payload.blogId) return;
      state.comments = action.payload.data.data;
      state.commentsTotal = action.payload.data.total;
      state.commentsLoading = false;
    },
    setCommentsError: (
      state,
      action: PayloadAction<{ blogId: number; error: string }>,
    ) => {
      if (state.commentsBlogId !== action.payload.blogId) return;
      state.commentsError = action.payload.error;
      state.commentsLoading = false;
    },
    updateBlog: (state, action: PayloadAction<IEditBlog>) => {
      const blogId = Number(action.payload.id);
      state.blogs = state.blogs.map((item) =>
        item.id === blogId ? { ...item, ...action.payload, id: blogId } : item,
      );
      if (state.blog?.id === blogId) {
        state.blog = { ...state.blog, ...action.payload, id: blogId };
      }
    },
    replaceBlog: (state, action: PayloadAction<IBlog>) => {
      state.blogs = state.blogs.map((item) =>
        item.id === action.payload.id ? action.payload : item,
      );
      if (state.blog?.id === action.payload.id) {
        state.blog = action.payload;
      }
    },
    deleteBlog: (state, action: PayloadAction<number>) => {
      const exists = state.blogs.some((item) => item.id === action.payload);
      state.blogs = state.blogs.filter((item) => item.id !== action.payload);
      if (exists) state.total = Math.max(state.total - 1, 0);
      if (state.blog?.id === action.payload) {
        state.blog = null;
      }
    },
    setLoadingBlog: (state) => {
      state.loading = true;
    },
    disableLoadingBlog: (state) => {
      state.loading = false;
    },
    setLoadingBlogId: (state, action: PayloadAction<number | null>) => {
      state.loadingBlogId = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setBlogs,
  setBlog,
  loadComments,
  setComments,
  setCommentsError,
  updateBlog,
  replaceBlog,
  deleteBlog,
  setLoadingBlog,
  disableLoadingBlog,
  setLoadingBlogId,
} = blog.actions;

export default blog.reducer;
